/// <reference path="client.d.ts" />
import AWSAppSyncClient from "aws-appsync";
import { AUTH_TYPE } from "aws-appsync/lib/link/auth-link";
import AWS from "aws-sdk";
import config from "./config";
const updateSubscription = require('src/services/graphql/queries/UpdateSubscription.graphql');

let jwtToken =  "";

const currentConfig = Object.assign({}, config, {
    auth: {
        type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
        jwtToken: () => jwtToken
    }
});

const subscriptionCallbacks = [];

export function subscriptionToUpdate(callOptions) {
    subscriptionCallbacks.push(callOptions);
}

export function getClient(_jwtToken){    
    jwtToken = _jwtToken;
    const client =  new AWSAppSyncClient(currentConfig);
    const { writeQuery, writeFragment } = client
    client.writeFragment = function () {
      writeFragment.apply(client, arguments)
      client.queryManager.broadcastQueries()
    }
    client.writeQuery = function () {
      writeQuery.apply(client, arguments)
      client.queryManager.broadcastQueries()
    }

    // Subscribing to the client
    client.subscribe({ query: updateSubscription }).subscribe({
        next: data => {
            // console.log(subscriptionCallbacks);
            subscriptionCallbacks.forEach(callback => {
                if (typeof callback.next === 'function') {
                    callback.next(data);
                }
            })
        },
        error: error => subscriptionCallbacks.forEach(callback => {
            if (typeof callback.error === 'function') {
                callback.error(error);
            }
        }),
        complete: subscriptionCallbacks.forEach(callback => {
            if (typeof callback.complete === 'function') {
                callback.complete();
            }
        })
    });
    return client;
}


// WEBPACK FOOTER //
// ./src/services/app-sync/client.js